import { useEffect, useState } from "react";

import { Label, Typography } from "@king-ict/eupisi-ui/components";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { getCommitteeDecisionList } from "../../api/Request/RequestApi";
import { InstitutionCodeBook } from "../../models";
import { Committee } from "../../models/Committee";
import { Request, RequestStatus, RequestType, CommitteeDecision } from "../../models/Request";
import { useGetInstitutionListQuery } from "../../queries/codeBookQuery";
import { FormatUtils, MsgUtils } from "../../utils";
import { FormCard } from "./FormCard";

export interface RequestHeaderProps {
  request: Request
}

export const RequestHeader = ({ request }: RequestHeaderProps) => {
  const { t } = useTranslation();
  const [types] = useState<CodeBook[]>(MsgUtils.getEnumToCodeBook(RequestType, "requestType"));
  const { data: institutions } = useGetInstitutionListQuery();
  const [primaryInstitution, setPrimaryInstitution] = useState<InstitutionCodeBook | undefined>();
  const [committeeDecisions, setCommitteeDecisions] = useState<CommitteeDecision[]>([]);

  useEffect(() => {
    if (!request?.institutionId || !institutions) return;
    setPrimaryInstitution(institutions?.find((i) => i.id === request.institutionId));
  }, [request.institutionId, institutions]);
  useEffect(() => {
    (async () => {
      if (request.institutionCommitteeId) {
        var committeeDecisions = await getCommitteeDecisionList(request.id);
        if (committeeDecisions) {
          const institutionCommitteeDecisions = committeeDecisions.filter(v => v.committeeEmployee?.committeeId === request.institutionCommitteeId);
          setCommitteeDecisions(institutionCommitteeDecisions);
        }
      }
    })();
  }, [request.id, request.institutionCommitteeId]);

  if (!request) return null
  return (
    <FormCard>
      <Row>
        <Col md={6}>
          <Typography>
            {request.childDetails?.firstName} {request.childDetails?.lastName}, OIB: {request.childDetails?.person.oib}
          </Typography>
        </Col>
        <Col md={6}>
          <Typography>
            {t("common.requestModel.requestType")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Typography>
            {t("common.schoolCandidateModel.dateOfBirth")}: {request.childDetails?.dateOfBirth ? hrDate(request.childDetails?.dateOfBirth) : ""}
          </Typography>
        </Col>
        <Col md={6}>
          <Label color={FormatUtils.getRequestTypeColor(request.type)} className="text-center" outline={false} fullWidth={false}>
            {types.find(v => v.id === request.type)?.name}
          </Label>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Typography>
            {t("common.schoolCandidateModel.permanentAddress")}: {FormatUtils.getAddressString(request.childDetails?.residence?.permanentAddress, request.childDetails?.residence?.address)}
          </Typography>
        </Col>
        <Col md={6}>
          <Typography>
            {t("common.requestModel.requestTabs.institutionCommitteeDecisionInfo")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Typography>
            {t("common.schoolCandidateModel.temporaryAddress")}: {FormatUtils.getAddressString(request.childDetails?.residence?.temporaryAddress)}
          </Typography>
        </Col>
        <Col md={6}>
          <Typography>
            {committeeDecisions && committeeDecisions.length > 0 ? t("common.yes") : t("common.no")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Typography>
            {t("request.primaryInstitution")}: {primaryInstitution?.name}
          </Typography>
        </Col>
        <Col md={6}>
          <Typography>
            {t("request.countyDecisions")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Typography>
            {t("request.hasSecondaryInstitution")}: {request.isOutsideEnrollmentArea ? t("common.yes") : t("common.no")}
          </Typography>
        </Col>
        <Col md={1}>
          {t("common.status")}:
        </Col>
        <Col md={4}>
          <Label
            color={FormatUtils.getRequestStatusColor(request.statusId)}
            className="text-center" outline={false} fullWidth={false}
          >
            {MsgUtils.getEnumToCodeBook(RequestStatus, "requestStatus").find(v => v.id === request.statusId)?.name}
          </Label>
        </Col>
      </Row>
    </FormCard>
  );
};
